export  enum Actions {
    SET_ADMIN_TILES = "SET_ADMIN_TILE",
    REMOVE_OBO_CONTEXT= "REMOVE_OBO_CONTEXT"
}